import { render } from "./MainDashiew.vue?vue&type=template&id=311aeb93&scoped=true"
import script from "./MainDashiew.vue?vue&type=script&lang=js"
export * from "./MainDashiew.vue?vue&type=script&lang=js"

import "./MainDashiew.vue?vue&type=style&index=0&id=311aeb93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311aeb93"]])

export default __exports__